export type LiveThoughtProcessStatusInput = {
  isLive: boolean;
  /**
   * Hops the timeline will actually draw. A host that reserves a placeholder
   * hop must not count it: the status is what tells the user the run is still
   * working, so anything the reader cannot see is not progress.
   */
  visibleHopCount: number;
  hasReasoning: boolean;
  loadingStatus: string;
  thinkingPhases?: ReadonlySet<string>;
};

export type LiveThoughtProcessStatus = {
  statusLabel: string;
  placement: "body" | "pill" | null;
};

const DEFAULT_THINKING_PHASES: ReadonlySet<string> = new Set(["Thinking..."]);

export function resolveLiveThoughtProcessStatus({
  isLive,
  visibleHopCount,
  hasReasoning,
  loadingStatus,
  thinkingPhases = DEFAULT_THINKING_PHASES,
}: LiveThoughtProcessStatusInput): LiveThoughtProcessStatus {
  const trimmed = loadingStatus.trim();
  const isThinkingPhase = !trimmed || thinkingPhases.has(trimmed);
  const statusLabel = isThinkingPhase ? "Thinking..." : trimmed;
  const waitingOnFirstHop = isLive && visibleHopCount === 0;

  let placement: LiveThoughtProcessStatus["placement"] = null;
  if (waitingOnFirstHop && !hasReasoning) placement = "body";
  else if (waitingOnFirstHop && !isThinkingPhase) placement = "pill";

  return { statusLabel, placement };
}
